module.exports = __webpack_public_path__ + "static/media/undo.1104d1d8.svg";